import { ReactElement } from 'react';

import { IconFillColor, IconSize, IconWrapper, NotesIcon } from '@dreryk/react-components';

type AppointmentsTimetableEventNotePresenceIconProps = {
   notePresent: boolean;
};

export const AppointmentsTimetableEventNotePresenceIcon = (
   props: AppointmentsTimetableEventNotePresenceIconProps
): ReactElement | null => {
   if (!props.notePresent) {
      return null;
   }
   return (
      <IconWrapper testId={'notePresent'} fillColor={IconFillColor.PRIMARY} size={IconSize.SMALLEST}>
         <NotesIcon />
      </IconWrapper>
   );
};
